<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('recharge.recharge') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <section class="km-section">
        <!-- Balance hero -->
        <div class="kr-balance">
          <div class="kr-balance__glow"></div>
          <div class="kr-balance__lbl">{{ $t('recharge.curr_balance') }}</div>
          <div class="kr-balance__val">
            <span class="kr-balance__num">{{ formatMoney(balance) }}</span>
            <span class="kr-balance__unit">{{ $t('reservation.unit') }}</span>
          </div>
          <div class="kr-balance__sub">Top up to keep sending gifts & super likes 💖</div>
        </div>
      </section>

      <section class="km-section">
        <div class="km-sec-head">Amount</div>
        <div class="km-card">
          <label class="km-field">
            <span class="km-field__lbl">{{ $t('recharge.input_money') }}</span>
            <input v-model="money" type="number" inputmode="decimal" :placeholder="$t('recharge.input_money')"/>
          </label>
        </div>
        <div class="kr-presets">
          <button
            v-for="amt in presets" :key="amt"
            class="kr-preset" :class="{ active: String(money) === String(amt) }"
            @click="money = String(amt)"
          >
            <span class="kr-preset__amt">{{ amt }}</span>
            <span class="kr-preset__unit">{{ $t('reservation.unit') }}</span>
          </button>
        </div>
      </section>

      <section class="km-section">
        <div class="km-sec-head">{{ $t('recharge.pay_way') }}</div>
        <div class="km-card">
          <button
            v-for="m in methods" :key="m.id"
            class="km-row" :class="{ active: pay_way === m.id }"
            @click="pay_way = m.id"
          >
            <span class="km-row__ico" :style="{ background: m.color }">{{ m.emoji }}</span>
            <div class="kr-method-body">
              <span class="kr-method-name">{{ m.name }}</span>
              <span class="kr-method-desc">{{ m.desc }}</span>
            </div>
            <span class="km-row__radio"></span>
          </button>
        </div>
      </section>

      <section class="km-section">
        <button class="km-btn" @click="onSubmit({ money })">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm1 15h-2v-4H7l5-5 5 5h-4Z"/></svg>
          Continue to payment
        </button>
        <p class="kr-secure">🔒 Secured by encrypted payment. We never store your card.</p>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      balance: 0,
      pay_way: "Mexicopay",
      win_money: 0,
      money: "",
      personalreport: {},
      presets: [100, 500, 1000, 2000, 5000, 10000],
      methods: [
        { id: 'Mexicopay', name: 'MexicoPay', desc: 'Cards, bank transfer, OXXO', emoji: '💳', color: 'linear-gradient(135deg,#60a5fa,#3b82f6)' }
      ]
    };
  },
  mounted() { this.balance = this.$route.params.balance; },
  methods: {
    back() { return window.history.back(); },
    formatMoney(v) {
      const n = Number(v);
      if (isNaN(n)) return '0.00';
      return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    onSubmit(values) {
      const money = values.money;
      if (!money || Number(money) <= 0) { this.$toast(this.$t("reservation.money_err")); return; }
      this.$http({ method: "post", data: { pay_way: this.pay_way, money: money }, url: "recharge" }).then(res => {
        if (res.code === 200) window.location.href = res.data.pay_url;
        else if (res.code === 401) this.$toast(res.msg);
      });
    },
    getPersonalreport() {
      this.$http({ method: "get", url: "user_get_personalreport" }).then(res => {
        if (res.code === 200) {
          this.personalreport = res.data;
          this.win_money = this.personalreport.win_money - this.personalreport.play_money;
        } else if (res.code === 401) { this.$toast(res.msg); }
      });
    }
  },
  created() {
    if (!localStorage.getItem("token")) this.$router.push({ path: "/Login" });
    else this.getPersonalreport();
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";

.kr-balance {
  position: relative; overflow: hidden;
  background: linear-gradient(135deg, #1a1033 0%, #4a1a6e 100%);
  color: #fff; border-radius: 18px; padding: 22px 20px;
  box-shadow: 0 14px 36px rgba(74,26,110,.25);
  text-align: center;
}
.kr-balance__glow {
  position: absolute; inset: 0;
  background:
    radial-gradient(circle at 20% 0%, rgba(255,77,141,.4), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(160,32,240,.4), transparent 55%);
  pointer-events: none;
}
.kr-balance__lbl { position: relative; font-size: 12px; opacity: .85; font-weight: 600; letter-spacing: .05em; text-transform: uppercase; }
.kr-balance__val { position: relative; display: flex; align-items: baseline; justify-content: center; gap: 6px; margin: 8px 0; }
.kr-balance__num { font-size: 32px; font-weight: 800; letter-spacing: -.02em; }
.kr-balance__unit { font-size: 13px; opacity: .8; font-weight: 600; }
.kr-balance__sub { position: relative; font-size: 12px; opacity: .75; }

.kr-presets {
  margin-top: 12px;
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px;
}
.kr-preset {
  background: #fff; border: 1.5px solid rgba(255,77,141,.18);
  border-radius: 12px; padding: 12px 8px; cursor: pointer;
  display: flex; flex-direction: column; align-items: center; gap: 2px;
  font-family: inherit; transition: all .2s;
}
.kr-preset:hover { border-color: #ff4d8d; transform: translateY(-1px); }
.kr-preset.active {
  background: linear-gradient(135deg, rgba(255,77,141,.1), rgba(160,32,240,.1));
  border-color: #ff4d8d;
  box-shadow: 0 6px 14px rgba(255,77,141,.15);
}
.kr-preset__amt { font-size: 15px; font-weight: 800; color: #2a1a3f; letter-spacing: -.01em; }
.kr-preset__unit { font-size: 10px; color: #8d7fa6; text-transform: uppercase; letter-spacing: .05em; }

.kr-method-body { flex: 1; display: flex; flex-direction: column; min-width: 0; }
.kr-method-name { font-size: 14px; font-weight: 700; color: #2a1a3f; }
.kr-method-desc { font-size: 11px; color: #8d7fa6; margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.km-row.active .kr-method-name { color: #ff4d8d; }

.kr-secure {
  font-size: 11px; color: #8d7fa6; text-align: center;
  margin: 10px 0 0; font-weight: 500;
}
</style>
